import { LucideIcon } from "lucide-react";

/** Stylized "Settings row" callout used by extended-tour deep-dive steps. */
export function SettingDeepDive({
  Icon,
  rowTitle,
  rowSubtitle,
  rowValue,
  rowValueTone = "muted",
}: {
  Icon: LucideIcon;
  rowTitle: string;
  rowSubtitle: string;
  rowValue: string;
  rowValueTone?: "muted" | "blue" | "green" | "red";
}) {
  const valueClass =
    rowValueTone === "blue"
      ? "text-[var(--roava-blue)]"
      : rowValueTone === "green"
        ? "text-[var(--roava-green)]"
        : rowValueTone === "red"
          ? "text-[var(--roava-red)]"
          : "text-[var(--roava-text-muted)]";

  return (
    <div className="mt-3 rounded-2xl border border-[var(--roava-border)] bg-[var(--roava-bg-elev)] p-3">
      <p className="text-[11px] uppercase tracking-wider text-[var(--roava-text-muted)] mb-2">
        Where to find it
      </p>
      <div className="flex items-center gap-3 rounded-xl bg-[var(--roava-bg)] border border-[var(--roava-border)] px-3 py-2.5">
        <div className="size-9 rounded-lg bg-[var(--roava-blue)]/10 text-[var(--roava-blue)] grid place-items-center shrink-0">
          <Icon className="size-4.5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-[var(--roava-text)] truncate">{rowTitle}</p>
          <p className="text-[11px] text-[var(--roava-text-muted)] truncate">{rowSubtitle}</p>
        </div>
        <span className={`text-[12px] font-medium ${valueClass}`}>{rowValue}</span>
      </div>
    </div>
  );
}
